<template>
  <div class="card card-custom">
    <div class="card-body p-10">
      <!--begin::Signup-->
      <div class="login-form login-signup">
        <form class="form" ref="rform" novalidate="novalidate" id="kt_login_signup_form">
          <div class="pb-13 pt-lg-0 pt-5">
            <h3 class="font-weight-bolder text-dark font-size-h4">
              Înregistrează-te
            </h3>
            <p class="text-muted font-weight-bold">
              Completează formularul pentru a trimite cererea de înregistrare.
            </p>
          </div>
          <div class="form-group">
            <input
              class="form-control form-control-solid h-auto py-7 px-6 rounded-lg font-size-h6"
              type="text"
              placeholder="Nume Prenume"
              name="fullname"
              ref="fullname"
              autocomplete="off"
            />
          </div>
          <div class="form-group">
            <input
              class="form-control form-control-solid h-auto py-7 px-6 rounded-lg font-size-h6"
              type="email"
              placeholder="Email"
              name="email"
              ref="remail"
              autocomplete="off"
            />
          </div>
          <div class="form-group">
            <input
                class="form-control form-control-solid h-auto py-7 px-6 rounded-lg font-size-h6"
                type="tel"
                placeholder="Telefon"
                name="tel"
                ref="rtel"
                autocomplete="off"
            />
          </div>
          <div class="form-group">
            <input
              class="form-control form-control-solid h-auto py-7 px-6 rounded-lg font-size-h6"
              type="password"
              placeholder="Parola"
              name="password"
              ref="rpassword"
              autocomplete="off"
            />
          </div>
          <div class="form-group">
            <input
              class="form-control form-control-solid h-auto py-7 px-6 rounded-lg font-size-h6"
              type="password"
              placeholder="Confirmă parola"
              name="cpassword"
              ref="cpassword"
              autocomplete="off"
            />
          </div>
          <div class="form-group">
            <label class="checkbox mb-0">
              <input type="checkbox" name="agree" />
              <span class="mr-2"></span>
              Am citit și am înțeles
              <a href="#" class="ml-2">Termenii și conditiile</a>.
            </label>
          </div>
          <div class="form-group d-flex flex-wrap pb-lg-0 pb-3">
            <button
              ref="kt_login_signup_submit"
              class="btn btn-primary font-weight-bolder font-size-h6 px-8 py-4 my-3 mr-4"
              style="width:150px;"
            >
              Trimite
            </button>
            <button
              type="button"
              id="kt_login_signup_cancel"
              class="btn btn-light-primary font-weight-bolder font-size-h6 px-8 py-4 my-3"
              @click="showForm('signin')"
            >
              Anulează
            </button>
          </div>
        </form>
      </div>
      <!--end::Signup-->
    </div>
  </div>
</template>

<style lang="scss">
@import "@/assets/sass/pages/login/login-1.scss";
</style>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import formValidation from "@/assets/plugins/formvalidation/dist/es6/core/Core";
import Swal from "sweetalert2";

// FormValidation plugins
import Trigger from "@/assets/plugins/formvalidation/dist/es6/plugins/Trigger";
import Bootstrap from "@/assets/plugins/formvalidation/dist/es6/plugins/Bootstrap";
import SubmitButton from "@/assets/plugins/formvalidation/dist/es6/plugins/SubmitButton";

import KTUtil from "@/assets/js/components/util";
import {
  REGISTER
} from "@/core/services/store/auth.module";

export default {
  name: "add-user",
  data() {
    return {};
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Admin" },
      { title: "Adaugă un nou utilizator" }
    ]);

    //
    const signup_form = KTUtil.getById("kt_login_signup_form");

    this.fv1 = formValidation(signup_form, {
      fields: {
        fullname: {
          validators: {
            notEmpty: {
              message: "Introdu numele complet"
            }
          }
        },
        email: {
          validators: {
            notEmpty: {
              message: "Introdu o adresa de email"
            },
            emailAddress: {
              message: "Introdu o adresa de email valida"
            }
          }
        },
        tel: {
          validators: {
            notEmpty: {
              message: "Introdu un numar de telefon"
            }
          }
        },
        password: {
          validators: {
            notEmpty: {
              message: "Introdu o parola"
            }
          }
        },
        cpassword: {
          validators: {
            notEmpty: {
              message: "Confirm password is required"
            },
            identical: {
              compare: function() {
                return signup_form.querySelector('[name="password"]').value;
              },
              message: "The password and its confirm are not the same"
            }
          }
        },
        agree: {
          validators: {
            notEmpty: {
              message: "You should agree terms and conditions"
            }
          }
        }
      },
      plugins: {
        trigger: new Trigger(),
        submitButton: new SubmitButton(),
        bootstrap: new Bootstrap()
      }
    });

    this.fv1.on("core.form.valid", () => {
      const name = this.$refs.fullname.value;
      const email = this.$refs.remail.value;
      const tel = this.$refs.rtel.value;
      const password = this.$refs.rpassword.value;

      // clear existing errors
      // this.$store.dispatch(LOGOUT);

      // set spinner to submit button
      const submitButton = this.$refs["kt_login_signup_submit"];
      submitButton.classList.add("spinner", "spinner-light", "spinner-right");

      // dummy delay
      setTimeout(() => {
        // send register request
        this.$store
          .dispatch(REGISTER, {
            name: name,
            email: email,
            password: password,
            password_confirmation: password,
            phone: tel
          })
            .then(() => {
              Swal.fire({
                title: "",
                text: "Contul a fost inregistrat!",
                icon: "success",
                confirmButtonClass: "btn btn-secondary",
                heightAuto: false
              }).then((result) => {
                if (result.isConfirmed) {
                  this.$refs.rform.reset();
                }
              })
            })

        submitButton.classList.remove(
          "spinner",
          "spinner-light",
          "spinner-right"
        );
      }, 2000);
    });

    this.fv1.on("core.form.invalid", () => {
      Swal.fire({
        title: "",
        text: "Completeaza toate campurile!",
        icon: "error",
        confirmButtonClass: "btn btn-secondary",
        heightAuto: false
      });
    });
  },
  methods: {
  },
  computed: {}
};
</script>
